import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import Seo from '~/components/functional/Seo/EditorialSeo.vue';
import OpenGraph from '~/components/functional/OpenGraph/EditorialOpenGraph.vue';
import TcVars from '~/components/functional/TcVars/EditorialTcVars.vue';
import { PRISMIC_URL, WOOSMAP_KEY, WOOSMAP_RECOMMENDATION } from '~/const/3rd';
import { formatPrismicImage } from '~/helpers/image-helper';
import { componentList, typeDefinition, buildSlices } from '~/helpers/editorial-helper';
import { fetchContent } from '~/services/editorial';
import HomeJsonld from '~/components/functional/JsonLD/HomepageJsonld.vue';
import RatingJsonLd from '~/components/functional/RatingJsonLd.vue';
var components = {};

var MarketSwitcher = function MarketSwitcher() {
  return import(
  /* webpackChunkName: "market-switcher" */
  '~/components/atoms/Global/MarketSwitcher.vue');
};

componentList().forEach(function (e) {
  components[e.type || e.name] = function (slug) {
    return {
      component: import("~/components/organisms/Editorial/".concat(slug))
    };
  };
});
export default {
  name: 'Home',
  components: {
    Seo: Seo,
    OpenGraph: OpenGraph,
    TcVars: TcVars,
    HomeJsonld: HomeJsonld,
    RatingJsonLd: RatingJsonLd
  },
  asyncData: function () {
    var _asyncData = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(_ref) {
      var error, apolloProvider, store, definition, _ref2, _ref2$results, _ref2$results$, id, data, slices;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              error = _ref.error, apolloProvider = _ref.app.apolloProvider, store = _ref.store;
              _context.prev = 1;
              definition = typeDefinition('home');
              _context.next = 5;
              return fetchContent(store, {
                type: 'home'
              });

            case 5:
              _ref2 = _context.sent;
              _ref2$results = _slicedToArray(_ref2.results, 1);
              _ref2$results$ = _ref2$results[0];
              id = _ref2$results$.id;
              data = _ref2$results$.data;
              _context.next = 12;
              return buildSlices(definition, data, apolloProvider.defaultClient, store);

            case 12:
              slices = _context.sent;
              return _context.abrupt("return", {
                type: definition.type,
                template: {
                  path: definition.path,
                  data: data
                },
                id: id,
                slices: slices
              });

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](1);
              error({
                statusCode: 404,
                message: 'Not Found'
              });
              console.log(_context.t0);

            case 20:
              return _context.abrupt("return", false);

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 16]]);
    }));

    function asyncData(_x) {
      return _asyncData.apply(this, arguments);
    }

    return asyncData;
  }(),
  data: function data() {
    return {
      marketSwitcher: null
    };
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })),
  httpHeaders: function httpHeaders() {
    return {
      'Cache-Control': 'max-age=0, s-maxage=360, public'
    };
  },
  created: function created() {
    var _this = this;

    if (this.template.path) {
      this[this.type] = function () {
        return components[_this.type](_this.template.path);
      };
    }

    this.slices.forEach(function (_ref3) {
      var type = _ref3.type,
          path = _ref3.path;

      _this[type] = function () {
        return components[type](path);
      };
    });
  },
  beforeMount: function beforeMount() {
    var prismicEdit = this.$cookies.get('editor');

    if (prismicEdit) {
      window.prismic = {
        endpoint: this.$store.state.sharedEnv.payload.prismic
      };
      this.asyncScript(PRISMIC_URL).then(function () {}).catch(function (err) {
        console.error('PRISMIC FAILED', err);
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (!this.$cookies.get('MARKET_SWITCHER_DISMISSED') && window.woosmapRecommendation) {
      var that = this;
      window.woosmapRecommendation.setProjectKey(WOOSMAP_KEY);
      window.woosmapRecommendation.getUserPosition({
        successCallback: function successCallback(latlng) {
          if ('latitude' in latlng) {
            var US_BOUND_BOX = {
              lat: {
                north: 49.3457868,
                south: 24.7433195
              },
              lng: {
                west: -124.7844079,
                east: -66.9513812
              }
            };

            if (US_BOUND_BOX.lat.south < latlng.latitude < US_BOUND_BOX.lat.north && US_BOUND_BOX.lng.west < latlng.longitude < US_BOUND_BOX.lng.east) {
              that.marketSwitcher = MarketSwitcher;
              return;
            }
          }

          that.setMarketSwitcherOffCookie(3600 * 24);
        }
      });
    }

    if (this.$cookies.get('opensearch') === 1) {
      window.addEventListener('load', function () {
        _this2.$root.$emit('open-search-mobile');
      }, {
        passive: true
      });
      this.$root.$emit('open-search-mobile');
    }
  },
  destroyed: function destroyed() {
    this.$root.$emit('close-search-mobile');
  },
  methods: {
    currentComponent: function currentComponent(arg) {
      return this[arg];
    },
    options: function options(_ref4) {
      var backgroundColor = _ref4.global_background_color,
          image = _ref4.global_background_image;
      return process.browser ? _objectSpread({}, backgroundColor && {
        style: {
          backgroundColor: backgroundColor
        }
      }, image && image.url && {
        'data-bgset': formatPrismicImage(image.url),
        class: 'lazyload bg-center'
      }) : null;
    },
    setMarketSwitcherOffCookie: function setMarketSwitcherOffCookie(maxAge) {
      this.$cookies.set('MARKET_SWITCHER_DISMISSED', '1', {
        path: '/',
        maxAge: maxAge
      });
    }
  },
  head: function head() {
    return {
      script: [{
        src: WOOSMAP_RECOMMENDATION,
        body: true
      }]
    };
  }
};